import { useRef, useState } from 'react';
import { useSelector } from 'react-redux'
import { DataGrid, Modal } from '../../components';
import { DataGridButtonProps } from '../../components/data-grid/types';
import { getApiParams } from '../../redux/auth';
import { BodyType, createRequest } from '../../redux/base/request';
import { ApiResponse, verfiyResponse } from '../../redux/base/types/saga';
import { getLocalized } from '../../redux/localization';
import { adminAddContract, adminContracts } from '../../services/urls';
import { User } from '../dashboard/product-comment/type';
import ContractDetail from './detail';
import { Contract, RequestContract } from './type';
import crateAdminContract from "./create"
const Contracts = () => {

  const localize = useSelector(getLocalized);
  const [show, setShow] = useState(false);
  const { token, lang } = useSelector(getApiParams);
  const [user, setUser] = useState<User>();


  const data = useRef<Contract>({
    Code: "",
    Id: "",
    StartDate: "",
    EndDate: "",
    ContractStatusType: "",
    ContractStatusTypeId: 0,
    Amount: 0,
    ContractPaymentType: null,
    Product: {},
    Message: "",
    MessageDate: "",
    UnreadCount: 0,
    UserId: "",
    UserName: "",
    CustomerUser: {},
    SupplierAccount: {},

  })
  const columns = [
    {
      dataField: "Code",
      caption: localize.getString("code"),
    },
    {
      dataField: "UserName",
      caption: localize.getString("username")
    },
    {
      dataField : "SupplierAccount.AccountName",
      caption : localize.getString("supplier")
    },
 
    {
      dataField : "CustomerUser.Name",
      caption : localize.getString("customerName")
    },
    {
      dataField : "CustomerUser.Surname",
      caption : localize.getString("customerSurname")
    },
    {
      dataField: "Product.Name",
      caption: localize.getString("productCardName")
    },
    {
      dataField: "Amount",
      caption: localize.getString("amount")
    },
    {
      dataField: "ContractStatusType",
      caption: localize.getString("contractStatusType")
    },
    {
      dataField: "StartDate",
      caption: localize.getString("startDate"),
      dataType: "date"
    },
  ]
  const buttons: DataGridButtonProps[] = [
    {
      hint: "info",
      icon: "info",
      onClick: async (e: any) => {
        data.current = await e.row.data;
        setShow(true);
        const response: ApiResponse<User[]> = await createRequest({
          method: "GET",
          url: "/api/admin/accounts/get-user/" + data.current.UserId,
          bodyType: BodyType.formdata,
          token,
          body: {},
          lang,
        });
        if (verfiyResponse(response)) {
          setUser(response.Result[0])
        }
      },
    },
  ];
  return (
    <>
      <Modal
        coverModal={false}
        width={"50%"}
        visible={show}
        onHiding={() => setShow(false)}
        title={localize.getString("contractDetails")}
        height={"90%"}
        onSubmitClick={async () => {
          console.log("ok")
        }}
      >
        <ContractDetail data={data.current} user={user} />
      </Modal>
      <DataGrid
        columns={columns || []}
        buttons={buttons}
        url={adminContracts}
        getByIdUrl={adminContracts}
        refObject={{
          productCardId: "",
          userId: "",

        } as RequestContract
        }
        create={{
          lookup: {
            lookupUrl: ""
          },
          isJson: true,
          width: "40%",
          height: "40%",
          createUrl: adminAddContract,
          title: "Kontrat Ekle",
          component: crateAdminContract,
          validationGroup: "createAccountContract",
        }}
      />
    </>

  )
}

export default Contracts